namespace Matrix.DataAudit {

	@Serenity.Decorators.responsive()
	@Serenity.Decorators.panel()
	export class SingleSecurityHistoryDialog extends Serenity.TemplatedDialog<any> {

        public grid: SingleSecurityHistoryGrid;

        constructor() {
            super();

			this.grid = new SingleSecurityHistoryGrid(this.element.children());
        }

        protected getTemplate() {
			return "<div style='height: 100%; flex: 1 1 100%;'></div>";
        }
    }
}